<div class="block-wrapper" *ngIf="!!block">
  <app-file-picker *ngIf="blocksConfig.uploadable; else imageTemplate"
                   [mimeTypes]="['image/jpg', 'image/png', 'image/jpeg']"
                   (fileChange)="onFile($event)"
                   [file]="block.file.default_url || block.settings.localFileUrl"
                   translation="blocks.Block::Image"
                   appearance="area"
                   [clickDisabled]="!blockComponent?.selected">

    <pl-icon class="icon ml-3 ml-sm-0" icon="builderImage"></pl-icon>
    <pl-icon class="icon-overlay ml-3 ml-sm-0" icon="builderImage"></pl-icon>

    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
  </app-file-picker>
</div>

<ng-template #imageTemplate>
  <div class="image-alignment-wrapper d-flex flex-column {{block.styles.align}} position-relative w-100">
    <div [style.max-width]="block.styles.width.formatted" class="w-100 image-size-wrapper">
      <div [class.embed-responsive]="!!block.aspect_ratio" [style.padding-bottom.%]="block.aspect_ratio">
        <img *ngIf="!!block.file.default_url"
             [src]="block.file.default_url"
             [alt]="block.settings.altText"
             class="img-fluid embed-responsive-item {{block.file.uploadError  ? 'error' : ''}}"
             (load)="blocksConfig.uploadable && imageLoaded($event)"
             [style.border-radius.px]="block.styles.border_radius"
             [style.border-style]="block.styles.border.active ? 'solid' : 'none'"
             [style.border-color]="block.styles.border.color"
             [style.border-width.px]="block.styles.border.active ? block.styles.border.width : 0"
             [attr.loading]="blocksConfig.editable || blocksConfig.submittable ? 'lazy' : null">

        <!-- Only shows in loading state !-->
        <div class="loading-wrapper d-flex flex-column {{block.styles.align}}"
             *ngIf="uploadingBlob?.uploadTrustedLocalFileUrl && previewEnabled"
             [class.embed-responsive-item]="!!block.aspect_ratio">
          <ng-container *ngIf="uploadingBlob.uploadPercentage > -1">
            <div class="loading-overlay"></div>
            <p class="loading-spinner">
              <app-loading-spinner class="mr-1" style="--loading-spinner-color: #ccc;"></app-loading-spinner>
              {{uploadingBlob.uploadPercentage | number:'1.0-0'}}%</p>
          </ng-container>

          <img [src]="uploadingBlob.uploadTrustedLocalFileUrl"
               [alt]="block.settings.altText"
               class="loading img-fluid embed-responsive-item {{uploadingBlob.uploadError ? 'error' : ''}}"
               (load)="blocksConfig.uploadable && previewImageLoaded($event)"
               [style.border-radius.px]="block.styles.border_radius"
               [style.border-style]="block.styles.border.active ? 'solid' : 'none'"
               [style.border-color]="block.styles.border.color"
               [style.border-width.px]="block.styles.border.active ? block.styles.border.width : 0">
        </div>
      </div>
    </div>
  </div>
</ng-template>
